export default __webpack_public_path__ + "static/media/icn_riders.fc389aa4.svg";